import type { MicroAgent } from "@newrelic/browser-agent";
import { container } from "tsyringe";
import { InstantConfigService } from "../services/InstantConfig";

interface NewRelicOptions {
  version: string;
  sampleRate: number;
}

export class NewRelicLoader {
  private agent: MicroAgent | undefined;

  constructor(private readonly options: NewRelicOptions) {}

  private isEnabled(): boolean {
    return container.resolve(InstantConfigService).get("icNewRelic");
  }

  public async load(): Promise<void> {
    const enabled = this.isEnabled();
    console.log(`[IE] NewRelic is ${enabled ? "enabled" : "disabled"}`);
    if (!enabled) {
      return;
    }

    if (Math.random() > this.options.sampleRate) {
      return;
    }

    console.log(this.options);
    const { MicroAgent } = await import(
      /* webpackChunkName: "nr-agent" */ "./new-relic-agent"
    );
    this.agent = new MicroAgent({
      info: {
        beacon: "bam.eu01.nr-data.net",
        errorBeacon: "bam.eu01.nr-data.net",
        licenseKey: "NRJS-b979b7ac62a2815b308",
        applicationID: "538605062",
        sa: 1,
      },
      loader_config: {
        accountID: "4475772",
        trustKey: "4475772",
        agentID: "538605062",
        licenseKey: "NRJS-b979b7ac62a2815b308",
        applicationID: "538605062",
      },
      init: {
        ajax: { enabled: false },
        distributed_tracing: { enabled: false },
        jserrors: { enabled: true },
        metrics: { enabled: true },
        page_action: { enabled: true },
        page_view_timing: { enabled: false },
        session_trace: { enabled: false },
        session_replay: { enabled: false },
        privacy: { cookies_enabled: true },
        spa: { enabled: false },
      },
    });
  }

  captureException(error: Error): void {
    this.agent?.noticeError(error);
  }

  addPageAction(name: string, attributes?: object) {
    this.agent?.addPageAction(name, attributes);
  }
}
